import {
  differenceInCalendarDays,
  differenceInCalendarMonths,
  isSameMonth,
} from "date-fns"

export const MODE = {
  ENERGY: "energy",
  FINANCE: "finance",
  BOTH: "both",
}

export const BUCKET = {
  MINUTE: "minute",
  DAY: "day",
  MONTH: "month",
  YEAR: "year",
}

/**
 * Map of bucket sizes to Pandas frequency offset aliases for the Repower API.
 */
const BUCKET_FREQ_MAP = {
  [BUCKET.MINUTE]: "15min",
  [BUCKET.DAY]: "1D",
  [BUCKET.MONTH]: "MS",
  [BUCKET.YEAR]: "YS",
}

// Maximum number of days in range for minute bucket size
const DAYS_MINUTE = 4
// Maximum number of days in range for day bucket size
const DAYS_DAY = 28
// Maximum number of months in range for month bucket size
const MONTHS_YEAR = 12

/**
 * Get the appropriate bucket size for a given date range.
 */
export function getBucketSize(dateRange) {
  const days = 1 + differenceInCalendarDays(dateRange[1], dateRange[0])
  const months = 1 + differenceInCalendarMonths(dateRange[1], dateRange[0])
  // If the date range is contained in a single month, force the use of the day
  // bucket.
  const forceDayBucket = isSameMonth(dateRange[0], dateRange[1])

  if (days <= DAYS_MINUTE) {
    return BUCKET.MINUTE
  } else if (forceDayBucket || days <= DAYS_DAY) {
    return BUCKET.DAY
  } else if (months <= MONTHS_YEAR) {
    return BUCKET.MONTH
  } else {
    return BUCKET.YEAR
  }
}

export function getBucketFreq(bucketSize) {
  return BUCKET_FREQ_MAP[bucketSize]
}
